/**
 * Stable CSS class names for E2E — Product detail store filter drawer.
 */
export const PDSF = {
    form: 'product-detail-store-filter__form',
    container: 'product-detail-store-filter__container',
    gridRoot: 'product-detail-store-filter__grid-root',

    headerRoot: 'product-detail-store-filter__header',
    headerTitle: 'product-detail-store-filter__header-title',
    headerCloseIcon: 'product-detail-store-filter__header-close-icon',

    cityAutocompleteWrap: 'product-detail-store-filter-input--city-autocomplete-wrap',
    countyAutocompleteWrap: 'product-detail-store-filter-input--county-autocomplete-wrap',
    sizeAutocompleteWrap: 'product-detail-store-filter-input--size-autocomplete-wrap',

    listButtonRow: 'product-detail-store-filter__list-button-row',
    listButton: 'product-detail-store-filter-input--button-list',
} as const;

export const pdsfCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

